import {
  ConnectionQualityLevels,
  ConnectionStates,
  DeviceErrors,
  StreamStates,
} from "@minervaproject/avsubsystem-core";

export enum BandwidthModeType {
  AudioOnly = "audio-only",
  AudioOnlyForced = "audio-only-forced",
  AutomaticBandwidth = "high",
  LimitedBandwidth = "low",
}

export type ReactionType =
  | "like"
  | "dislike"
  | "agree"
  | "disagree"
  | "laugh"
  | "wow"
  | "love"
  | "clap"
  | null;

export enum RoleType {
  Assistant = "assistant",
  BackupInstructor = "backup-instructor",
  Captioner = "captioner",
  GuestInstructor = "guest-instructor",
  Observer = "observer",
  Student = "student",
  TA = "ta",
  Teacher = "teacher",
  None = "",
}

export interface UserAvType {
  camera_error: DeviceErrors | null;
  connection_state: ConnectionStates | null;
  connection_quality: ConnectionQualityLevels | null;
  mic_error: DeviceErrors | null;
  published_stream_state: StreamStates | null;
}

export interface UserType {
  id: string;
  av: UserAvType;
  aws_avatar_key: string;
  bandwidth_mode: BandwidthModeType;
  blur_background: boolean;
  breakout_group_title?: string;
  breakout_talk_time?: number;
  class_user_id: string;
  classroom_talk_time?: number;
  cumulative_talk_time: number;
  email: string;
  enable_live_captions: boolean;
  enable_student_drawing: boolean;
  enter_class_time?: number;
  filter_count?: number;
  first_name: string;
  has_classroom_in_focus?: boolean;
  intercom_hash: string;
  is_hand_raised: boolean;
  is_performing_av_check: boolean;
  is_recording_agent: boolean;
  is_present: boolean;
  is_speaking: boolean;
  last_entered_at?: number;
  last_name: string;
  pronunciation_url?: string;
  ptt_mode: boolean;
  pref_camera_device_label: string | null;
  pref_mic_device_label: string | null;
  pubsub_connection_quality: string | null;
  reaction: ReactionType;
  role: RoleType;
  seconds_present: number;
  sort_order: number;
  title?: string;
  vote: VoteType;
  whiteboard_font_size_preference: "s" | "m" | "l" | "xl";
  whiteboard_stroke_size_preference: "s" | "m" | "l" | "xl";
  zoom_preference: ZoomPreferenceType;
}

export type VoteType = "no" | "yes" | null;

export enum ZoomPreferenceType {
  ZoomToFill = "zoom-to-fill",
  ZoomToFit = "zoom-to-fit",
}
